export const styles = {
  header: {
    gap: "10px",
    display: "flex",
    padding: "16px 24px",
    flexDirection: "column",
    backgroundColor: "white",
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  contentIcons: {
    display: "flex",
    flexDirection: "row",
    gap: "9px",
  },
  input: {
    display: "Flex",
    flexDirection: "column",
  },
  label: {
    color: "#9C9C9C",
    fontSize: "14px",
    fontWeight: 400,
  },
  select: {
    display: "flex",
    flexDirection: "column",
  },
  selectDocumento: {
    border: "1px solid #8686869f",
    borderRadius: "10px",
  },
  inputsContainer: {
    gap: "16px",
    display: "flex",
    alignItems: "flex-end",
  },
  inputLabel: {
    display: "flex",
    flexDirection: "column",
    marginTop: "10px",
    width: "200px",
    "&>input": {
      borderRadius: "8px",
    },
    "&>label": {
      fontSize: "12px",
      color: "#868686",
    },
  },
  InputForm: {
    border: "1px solid #9696964f",
    fontFamily: "Poppins",
    paddingLeft: "8px",
    borderRadius: "5px",
    paddingRight: "8px",
    background: "#f2f2f2",
  },
  dialog: {
    display: "flex",
    justifyContent: "space-between",
    minWidth: "830px",
    minHeight: "630px",
    padding: "10px",
    zIndex:1
  },
  dialogContent: {
    height: "100%",
    padding: "10px 24px 16px",
    overflow: "hidden",
  },
  contentButton: {
    display: "flex",
    justifyContent: "flex-end",
    height: "60px",
  },
  buttonImprimir: {
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    gap: "10px",
    width: "295px",
    height: "40px",
    padding: "16px",
  },
  textEditorWrapper: {
    maxWidth: "100%",
    height: "100%",
    overflow: "hidden",
  },
  textEditorScroll: {
    height: "100%",
    maxHeight: "100%",
    "& .jodit-react-container": {
      height: "100%",
      overflow: "hidden",
      "& .jodit-container": {
        height: "100% !important",
        "& .jodit-workplace": {
          height: "calc(100% - 39px) !important",
        },
      },
      "& .jodit_fullsize": {
        height: "100vh !important",
      },
      "& .jodit-wysiwyg": {
        minHeight: "121px",
        maxHeight: "250px",
        height: "250px",
      },
    },
  },
  inputContainer: {
    background: "#F2F2F2",
    color: "#505050",
    borderRadius: "8px",
    height: "30px",
    "&::placeholder": {
      opacity: 0.5,
    },
  },
};
